class s extends HTMLElement {
  constructor() {
    super(),
      (this.productForm = null),
      (this.option = {
        name: this.getAttribute('data-option-name'),
        position: Number(this.getAttribute('data-option-position')),
      }),
      (this.elements = {
        options: this.querySelectorAll('[data-option]'),
        fieldset: this.querySelector('[data-options-fieldset]'),
        trigger: {button: this.querySelector('[data-trigger]'), label: this.querySelector('[data-trigger-label]')},
      });
  }
  connectedCallback() {
    const t = this.getAttribute('data-form-id');
    (this.productForm = document.querySelector(`product-form[data-form-id="${t}"]`)),
      this.handleVariantChange(),
      this.elements.trigger.button.addEventListener('click', this.toggle.bind(this));
  }
  toggle(t, e) {
    if (
      (t == null || t.preventDefault(),
      this.elements.trigger.button.getAttribute('aria-expanded') === 'true' || e === 'close')
    ) {
      this.elements.trigger.button.setAttribute('aria-expanded', !1),
        this.elements.fieldset.setAttribute('aria-hidden', !0),
        this.elements.fieldset.setAttribute('inert', !0);
      return;
    }
    this.elements.trigger.button.setAttribute('aria-expanded', !0),
      this.elements.fieldset.setAttribute('aria-hidden', !1),
      this.elements.fieldset.removeAttribute('inert'),
      this.updateOptions();
  }
  handleVariantChange() {
    const t = this.productForm.querySelector('input[name="id"]');
    t &&
      t.addEventListener('variant_update', (e) => {
        var o;
        const i = (o = e.detail) == null ? void 0 : o.variant;
        i && (this.updateOptions(), this.updateTriggerLabel(i));
      });
  }
  updateTriggerLabel(t) {
    this.toggle(null, 'close');
    const e = t.options[this.option.position - 1];
    this.elements.trigger.label.textContent = e;
  }
  updateOptions() {
    const t = this.productForm.getActiveOptions(this.option.name);
    this.elements.options.forEach((e) => {
      const i = e.getAttribute('data-value'),
        o = t.find((n) => n.options[this.option.position - 1] === i);
      this.updateOption(e, o);
    });
  }
  updateOption(t, e) {
    const i = t.querySelector('input[type="radio"]'),
      o = t.querySelector('[data-option-note]');
    e ? i.removeAttribute('disabled') : i.setAttribute('disabled', !0);
    const n = this.getOptionNote(e);
    o.textContent = n;
  }
  getOptionNote(t) {
    var n;
    if (!t) return '';
    const e = window.theme.strings.products.variantSelect.optionNote,
      i = window.theme.settings.products.enableNotifyMe,
      o = window.theme.settings.products.enableLowStockThreshold;
    return i && !t.available
      ? e.notifyMe
      : t.available
        ? o && (n = t == null ? void 0 : t.custom) != null && n.is_low_stock
          ? e.fewRemaining.replace('{{ count }}', t.inventory_quantity)
          : ''
        : e.soldOut;
  }
}
function a() {
  customElements.define('component-variant-select', s);
}
export {a as i};
